import(/* webpackChunkName: "inclusionAutomat" */ '../../Styles/inclusionAutomat.scss');

await import(/* webpackChunkName: "forEach" */ 'Feature/Common/code/Scripts/Common/forEach');
await import(/* webpackChunkName: "InclusionAutomatResetButton" */ 'Feature/InclusionAutomat/code/Scripts/InclusionAutomat/InclusionAutomatResetButton');
await import(/* webpackChunkName: "InclusionAutomatNextButton" */ 'Feature/InclusionAutomat/code/Scripts/InclusionAutomat/InclusionAutomatNextButton');
await import(/* webpackChunkName: "InclusionAutomatQuestion" */ 'Feature/InclusionAutomat/code/Scripts/InclusionAutomat/InclusionAutomatQuestion');
await import(/* webpackChunkName: "InclusionAutomatPage" */ 'Feature/InclusionAutomat/code/Scripts/InclusionAutomat/InclusionAutomatPage');
await import(/* webpackChunkName: "InclusionAutomatPart" */ 'Feature/InclusionAutomat/code/Scripts/InclusionAutomat/InclusionAutomatPart');
await import(/* webpackChunkName: "InclusionAutomatRadioGroup" */ 'Feature/InclusionAutomat/code/Scripts/InclusionAutomat/InclusionAutomatRadioGroup');

window.InclusionAutomat = function (domNode)
{
    this.domNode = domNode;

    this.parts = [];
    this.offset = 32;

    this.resizeEvent = false;
    this.resizeEndEvent = false;


    this.init = function ()
    {
        const parts = this.domNode.querySelectorAll(".inclusion-automat__parts");

        for (let i = 0; i < parts.length; i++)
        {
            const automatPart = new window.InclusionAutomatPart(parts[i], this, i);

            if (i === 0)
            {
                automatPart.currentPart = true;
            }

            automatPart.init();
            this.parts.push(automatPart);
        }

        this.initSlider();
    };

    this.initSlider = function ()
    {
        let that = this;

        let currentPart = this.getCurrentPart();
        let topPosition = 0;

        for (let i = 0; i < this.parts.length; i++)
        {
            const part = this.parts[i];

            let left = -1 * ((currentPart.index - i) * (this.domNode.offsetWidth + this.offset));
            part.domNode.style.cssText = 'top: ' + topPosition + 'px; left: ' + left + 'px;';

            topPosition -= part.domNode.offsetHeight + 30; // 30 = margin-top
        }

        if (!this.resizeEvent)
        {
            this.resizeEvent = true;
            window.addEventListener("resize", function () { that.handleResize(that); });
        }

        if (!this.resizeEndEvent)
        {
            this.resizeEndEvent = true;
            window.addEventListener("resizeEnd", function () { that.handleResizeEnd(that); });
        }
    }

    this.goToPart = function (partNumber)
    {
        for (let i = 0; i < this.parts.length; i++)
        {
            const part = this.parts[i];
            part.currentPart = (i === (partNumber - 1));

            let left = -1 * (((partNumber - 1) - i) * (this.domNode.offsetWidth + this.offset));
            part.domNode.style.left = left + 'px';
            part.show();

            if (part.currentPart)
            {
                part.initCurrentPart();
                part.pages[0].radioGroups[0].radioButtons[0].domNode.focus();
            }
            else
            {
                part.terminateCurrentPart();
            }
        }
        
        this.initSlider();
    }

    this.goToNextPart = function (currentPartObj)
    {
        for (let i = 0; i < this.parts.length; i++)
        {
            const part = this.parts[i];

            if (part === currentPartObj)
            {
                let nextPossiblePart = i + 2; // +1 because of i starting at 0 and +1 for the next part

                if (nextPossiblePart <= this.parts.length)
                {
                    this.goToPart(nextPossiblePart);
                } else
                {
                    // Disable the button to prevent multiple clicks
                    const currentPage = part.pages[part.pages.length - 1];
                    currentPage.disableButtons();
                    // Redirect to summary page
                    this.handleSummary(currentPage);
                }
            }
        }
    }

    this.handleSummary = function (currentPage)
    {
        const api = "/api/sitecore/QuestionSummary/RedirectToResultPage";
        const redirectRequest = new XMLHttpRequest();

        redirectRequest.onload = function ()
        {
            if (this.readyState === 4)
            {
                if (this.status === 200 && redirectRequest.responseText !== "")
                {
                    top.location = redirectRequest.responseText;
                } else
                {
                    currentPage.onError();
                }
            }
        };

        redirectRequest.onerror = function ()
        {
            currentPage.onError();
        }

        redirectRequest.open("POST", api, true);
        redirectRequest.setRequestHeader("Content-Type", "application/json");
        redirectRequest.send(this.getSummary());
    }

    this.handleResizeEnd = function (part)
    {
        for (let i = 0; i < this.parts.length; i++)
        {
            const part = this.parts[i];
            part.show();
        }

        part.initSlider();
    }

    this.handleResize = function (part)
    {
        this.domNode.style.height = "";

        for (let i = 0; i < this.parts.length; i++)
        {
            const part = this.parts[i];

            part.domNode.style.cssText = "";
            if (!part.currentPart)
            {
                part.hide();
            }
        }
    }

    this.getCurrentPart = function ()
    {
        for (let i = 0; i < this.parts.length; i++)
        {
            const part = this.parts[i];

            if (part.currentPart)
            {
                return part;
            }
        }
    };

    this.getLargestPartHeight = function ()
    {
        let maxPartHeight = 0;
        for (let i = 0; i < this.parts.length; i++)
        {
            const part = this.parts[i];

            if (part.domNode.offsetHeight > maxPartHeight)
            {
                maxPartHeight = part.domNode.offsetHeight;
            }
        }

        return maxPartHeight;
    }

    this.getSummary = function ()
    {
        const summary = {};
        summary["contextItemId"] = this.domNode.getAttribute("data-ctx-item-id");
        summary["itemLanguage"] = this.domNode.getAttribute("data-ctx-item-language");

        for (let i = 0; i < this.parts.length; i++)
        {
            const part = this.parts[i];
            const propertyIndex = i + 1;
            summary['part' + propertyIndex] = {};
            summary['part' + propertyIndex]["total"] = 0;
            summary['part' + propertyIndex]["achieved"] = 0;

            part.pages.forEach(function (page)
            {
                page.questions.forEach(function (question)
                {
                    for (let j = 0; j < question.radioboxes.length; j++)
                    {
                        const radioBoxEm = question.radioboxes[j];
                        const radioBoxValue = radioBoxEm.getAttribute("value");

                        if (!radioBoxValue)
                        {
                            continue;
                        }

                        if (j === 0)
                        {
                            summary['part' + propertyIndex]["total"] += parseInt(radioBoxValue);
                        }

                        if (radioBoxEm.getAttribute("aria-checked") === "true")
                        {
                            summary['part' + propertyIndex]["achieved"] += parseInt(radioBoxValue);
                        }
                    }
                });
            });
        }

        return JSON.stringify(summary);
    };
};


await import(/* webpackChunkName: "InclusionAutomatInit" */ 'Feature/InclusionAutomat/code/Scripts/InclusionAutomat/InclusionAutomatInit');